/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_SHARE_CENTER_TAB,
  GET_SHARE_SETS,
  GET_SHARE_SETS_SUCCESS,
  GET_SHARE_SETS_ERROR,
  CLEAR_SHARE_SETS,
} from 'src/actions/shareCenterActions';

// CON-1552 — Share Center list state. The Share Sets list endpoint is
// unpaginated, so there is no query/restoration state yet; add it
// alongside pagination if the list ever grows server-side paging.
const initialState = {
  // 'apply' | 'mySets' — the tab bar only renders for SHARE_SETS_MANAGE
  // users; without MANAGE the page shows the apply content directly.
  currentTab: 'apply',
  shareSets: [],
  loading: false,
};

const shareCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHARE_CENTER_TAB: {
      return produce(state, (draft) => {
        draft.currentTab = action.payload.tab;
      });
    }

    case GET_SHARE_SETS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_SHARE_SETS_SUCCESS: {
      return produce(state, (draft) => {
        draft.shareSets = action.payload.shareSets;
        draft.loading = false;
      });
    }

    case GET_SHARE_SETS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_SHARE_SETS: {
      return produce(state, (draft) => {
        draft.shareSets = [];
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default shareCenterReducer;
